module.exports = __webpack_public_path__ + "media/assets/icon-login-1e6b2c4072d117c0974f87ff6cff1a88.svg";